import { Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Sidebar from './AnimatedList';
import "./Services.css";
import "./ServicePage.css";
import Banner from "../Img/Services Banner/Services Banner.jpg";

function Customs() {
  return (
    <>
      <Image className="fade-in responsive-img" src={Banner} height={500} width="100%" fluid />

      <div className="service-page">
        <section className="service-hero">
          <span className="service-hero__eyebrow">Our Services</span>
          <h1 className="service-hero__title">
            Custom <span>Clearance</span>
          </h1>
          <p className="service-hero__subtitle">
            End-to-end customs documentation and clearance for import, export, storage
            and transit shipments — handled by specialists who know the regulations.
          </p>
        </section>

        <div className="service-layout">
          <article className="service-content">
            <h2>Every Formality, Handled</h2>
            <p>
              You can contact <strong>MMOPL</strong> for various customs formalities with regard
              to export, import, storage and transit shipments. Both import and export require
              customs formalities with many different types of documents, which may differ per
              country and product.
            </p>

            <h2>Regulations, Done Right</h2>
            <p>
              Our customs declarants are specialized in these regulations and organize the necessary
              documents for your shipment. In this way, the import, export and transit of your loads
              takes place quickly and effectively. We also assist with VAT and duty management,
              veterinary inspections, and can advise you on specific customs or tax issues.
              Unburdening — that's what we stand for.
            </p>

            <h2>Our Customs Services</h2>
            <ul className="service-features">
              <li>Import and export customs clearance</li>
              <li>Transit and bonded cargo documentation</li>
              <li>VAT and duty management</li>
              <li>Veterinary and phytosanitary inspections</li>
              <li>Customs advisory for specific commodities</li>
              <li>Coordination with port and CFS authorities</li>
            </ul>

            <div className="service-info-banner">
              <div className="service-info-banner__icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <polyline points="14 2 14 8 20 8" />
                  <line x1="9" y1="13" x2="15" y2="13" />
                  <line x1="9" y1="17" x2="15" y2="17" />
                </svg>
              </div>
              <p>
                <strong>Zero-delay clearance:</strong> Accurate documentation the first time —
                no demurrage, no storage penalties, no customs surprises.
              </p>
            </div>

            <div className="service-cta">
              <h3>Clear Customs Without Delays</h3>
              <p>
                Send us your shipping bill, invoice and packing list — we'll take it
                from there and keep you informed at every step.
              </p>
              <Link to="/Contact" className="service-cta__btn">
                Get Started
              </Link>
            </div>
          </article>

          <Sidebar />
        </div>
      </div>
    </>
  );
}

export default Customs;